export const hashAnalyticsErrorId = (parts: Array<string | undefined>): string => {
  const value = parts.filter(Boolean).join('|');
  let hash = 0;

  for (let index = 0; index < value.length; index += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash |= 0;
  }

  return Math.abs(hash).toString(36);
};
